import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { REGISTRATION_CONFIG } from '@us-registration/util-models';

export const maintenanceGuard: CanActivateFn = (
  _route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router = inject(Router);
  const config = inject(REGISTRATION_CONFIG);
  const url = state.url;

  if (config.features.maintenanceEnabled && !url.startsWith('/maintenance')) {
    router.navigate(['/maintenance']);
    return false;
  }

  return true;
};
